import {Trans} from '@lingui/macro';
import React from 'react';

import {CollapsedItemKeyPrefixesEnum} from '../../models/api/localPreferencesModel';
import {useSettingsInfoBox, UseSettingsInfoBoxProps} from '../helpers/settingsInfoBox';

/*
 * Consts.
 */

const settingsInfoBox: UseSettingsInfoBoxProps = {
  settingsExpandedKey: CollapsedItemKeyPrefixesEnum.SETTINGS_CIRCLES,
  title: <Trans id="settings-circles-infobox-title">What are groups?</Trans>,
  body: (
    <Trans id="settings-circles-infobox-body">
      <p>
        Organize your company by groups to save time. Groups can be used in Rules and other parts of the app.
      </p>
    </Trans>
  ),
};

/*
 * Hook.
 */

export function useCirclesListInfoBox() {
  return useSettingsInfoBox(settingsInfoBox);
}
